import React,{FC} from 'react'

interface Props {
    header: [],
    
}

export const TableHeader:FC<Props> = ({ header  }) => {
  
  return (
    <thead className='text-capitalize' style={{ fontWeight:500,color:'#667085',background:"#d1fadf", fontSize:'14px'}}>
    <tr>
        {header?.map((item:any) => (
           
          <th  key={item?.fieldID} className="px-6 py-3">{item?.name}</th>
       
        ))}
    </tr>
  </thead>
  )
}


